import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Card, Col, Container } from 'reactstrap'
import { useSelector, useDispatch } from "react-redux";

import { getLabRequests, addNewLabRequest, updateLabRequest, getLabRequest, getLabRequestsReportDetail } from "../../store/labCitec/labRequest/actions"
import { getLabRequestAssignments } from "../../store/labCitec/labRequestAssignments/actions"
import { getLabRequestTests } from "../../store/labCitec/labRequestTest/actions"
import { BackButton } from '../../components/Common/BackButton'
import Breadcrumb from '../../components/Common/Breadcrumb'
import { Expander } from '../../components/Common/Expander'
import Table1 from "../../components/Common/TableContainer"
import TableNP from "../../components/Common/TableContainerNP"
import { TableItemDeleteModal } from '../../components/Common/TableItemDeleteModal'
import { LabCitecDetailsTestEditModal } from '../LabCitec/Requests/Information/Tests/LabCitecDetailsTestEditModal'
import { diffDays } from '../../helpers/mixFunctions'

export const ResultsSummary = (props) => {

  const [rowInfo, setRowInfo] = useState();
  const [showModal1, setShowModal1] = useState(false);
  const [showModal2, setShowModal2] = useState(false);

  const onDelete = (values) => {
    setRowInfo(values);
    // console.log('Valores delete: ', values);
    setShowModal2(true);
  }

  const onDeleteConfirmation = () => {
    // console.log('Borrado confirmado:', rowInfo); // TODO: Se supone que rowInfo sólo debe ser un Id, Confirmar si si borra bien
    // dispatch(deleteLabRequestTest(rowInfo));
    setRowInfo('');
  }

  const onUpdate = (values) => {
    // console.log('Valores update: ', values);
    setRowInfo(values);
    setShowModal1(true);
    
  }

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getLabRequest(`/${props.match.params.id}`))
    dispatch(getLabRequestAssignments(`?limit=20&page=0&labRequest=${props.match.params.id}`))
    dispatch(getLabRequestsReportDetail(`?labRequest=${props.match.params.id}`))
    dispatch(getLabRequestTests(`?limit=20&page=0&labRequest=${props.match.params.id}`))
  }, [])

  const { labRequest, labRequestAssignments, labRequestTests, labRequestsReportDetail
  } = useSelector(state => ({
    loading: state.labRequestReducer.loading,
    labRequest: state.labRequestReducer.labRequest,
    total: state.labRequestReducer.total,
    currentPage: state.labRequestReducer.currentPage,
    labRequestAssignments: state.labRequestAssignmentReducer.labRequestAssignments,
    labRequestTests: state.labRequestTestReducer.labRequestTests,
    labRequestsReportDetail: state.labRequestReducer.labRequestsReportDetail,
  }));

  // console.log('Valores labRequestsReportDetail: ', labRequestTests?.find(x => x?.labTest?.description === ''));

  const columns = React.useMemo(
    () => [
      // Expander,
      {
        Header: 'Norma',
        width: '12%',
        Cell: ({ row }) => (
          <div>
            { 
              // labRequestTests?.find(x => x?.labTest?.description === row.original?.description) !== undefined ? 
              // labRequestTests?.find(x => x?.labTest?.description === row.original?.description).labTest?.norm?.name ?? '-' : '-'
              row.original?.normName ?? '-'
            }
          </div>
        ),
      },
      {
        Header: 'Método',
        width: '12%',
        Cell: ({ row }) => (
          <div>
            <div>{row.original?.method ?? '-'}</div>
          </div>
        ),
      },
      // {
      //   Header: 'Nombre del ensayo',
      //   width: '15%',
      //   Cell: ({ row }) => (
      //     <div>
      //       <div>{row.original?.testName ?? '-'}</div>
      //     </div>
      //   ),
      // },
      // {
      //   Header: 'Costos de ensayos',
      //   width: '14%',
      //   Cell: ({ row }) => (
      //     <div>
      //       <div><strong>Materiales: </strong>$ {row.original?.materials ?? '-'}</div>
      //       <hr className='text-success m-2' style={{ height: 3 }} />
      //       <div><strong>Mano de Obra: </strong>$ {row.original?.workForce ?? '-'}</div>
      //     </div>
      //   ),
      // },
      {
        Header: 'Cantidad',
        width: '14%',
        Cell: ({ row }) => (
          <div>
            <div>{row.original?.essaysQuantity ?? '-'}</div>
            {/* <hr className='text-success m-2' style={{ height: 3 }} />
            <div><strong>Costo total de Terceros: </strong>$ {row.original?.totalThirdPartyCost ?? '-'}</div> */}
          </div>
        ),
      },
      {
        Header: 'Costos unitario',
        width: '14%',
        Cell: ({ row }) => (
          <div>
            {/* <div> <b>Costo de Material: </b> $ {row.original?.materialCost ?? '-'}</div>
            <div> <b>Costo de Mano de Obra: </b> $ {row.original?.workforceCost ?? '-'}</div> */}
            <div> <b>Costo Total: </b> $ {row.original?.totalCost?.toLocaleString('en-US', {maximumFractionDigits:2}) ?? '-'}</div>
            {/* <div> <b>Costo de Terceros: </b> $ {row.original?.thirdCost ?? '-'}</div> */}
            {/* <hr className='text-success m-2' style={{ height: 3 }} />
            <div><strong>Costo total de Terceros: </strong>$ {row.original?.totalThirdPartyCost ?? '-'}</div> */}
          </div>
        ),
      },
    ],
    []
  )

  const data = [
    {
      name: 'NMX-C-159-ONNCCE-2004',
      method: 'SGI-CITEC-SDL-ME-001',
      testName: 'MUESTREO DE AGREGADOS NMX-C-30-ONNCCE-2004',
      materials: 1500,
      workForce: 350,
      testsTotalCost: 1850,
      totalThirdPartyCost: 1550,
      statusTest: 'PENDIENTE',

      testNumber: 1,
      testDesc: 'Grava Triturada Caliza 05-10mm',
      quantity: 400,
      um: 'KG',
      testPerSample: 2,
    },
    {
      name: 'NMX-C-159-ONNCCE-2005',
      method: 'SGI-CITEC-SDL-ME-001',
      testName: 'MUESTREO DE AGREGADOS NMX-C-30-ONNCCE-2004',
      materials: 1500,
      workForce: 350,
      testsTotalCost: 1850,
      totalThirdPartyCost: 1550,
      statusTest: 'PENDIENTE',

      testNumber: 2,
      testDesc: 'Grava Triturada Caliza 05-10mm',
      quantity: 400,
      um: 'KG',
      testPerSample: 2,
    }
  ]

  const columns2 = React.useMemo(
    () => [
      {
        Header: 'No. muestra',
        width: '17%',
        Cell: ({ row }) => (
          <div>
            <div>{row.original?.testNumber ?? '-'}</div>
          </div>
        ),
      },
      {
        Header: 'Descripción de la muestra',
        width: '17%',
        Cell: ({ row }) => (
          <div>
            <div>{row.original?.testDesc ?? '-'}</div>
          </div>
        ),
      },
      {
        Header: 'Cantidad',
        width: '17%',
        Cell: ({ row }) => (
          <div>
            <div>{row.original?.quantity ?? '-'}</div>
          </div>
        ),
      },
      {
        Header: 'UM',
        width: '17%',
        Cell: ({ row }) => (
          <div>
            <div>{row.original?.um ?? '-'}</div>
          </div>
        ),
      },
      {
        Header: 'Ensayos por muestra',
        width: '17%',
        Cell: ({ row }) => (
          <div>
            <div>{row.original?.testPerSample ?? '-'}</div>
          </div>
        ),
      },
    ],
    []
  )

  // const renderRowSubComponent = React.useCallback(
  //   ({ row }) => (
  //       <div>
  //         <div className='text-left'>Observaciones: {row?.original?.observations ?? '-'}</div>
  //       </div>
  //   ),
  //   []
  // )

  const renderRowSubComponent = React.useCallback(
    ({ row }) => (
      // console.log('row:', row.original)
      // <div>
      //  <div className='text-left'>Observaciones: {JSON.stringify(row.original)}</div>
      // </div>

        <TableNP isAddTableBorderStrap columns={columns2} data={[row.original]} /> /* TODO: Esta "data" debe de ser la de cada renglón */
      
    ),
    []
  )

  return (
    <div className="page-content">
      <Container fluid className="" >
        <Col className="col-12" style={{ padding: 40 }}>
          <Card className='' style={{ padding: 20 }}>

            {/* TODO: Verificar el breadcrumb */}
            <Breadcrumb breadcrumbItem1='results' breadcrumbItem2='labTests' />

            <Card className='' style={{ padding: 20 }}>

              <div className='d-flex align-items-center justify-content-between'>
                <h4 className='text-success'>{`SOLICITUD DEL SERVICIO:  ${labRequest.code ?? '-'}`}</h4>
                <BackButton props={props} />
              </div>

              <hr className='text-primary mt-1' />

              <div className='d-flex align-items-center justify-content-between mt-2'>
                <h5 className='text-primary'>{`RESUMEN DE LA SOLICITUD`}</h5>
              </div>

              <div className='d-flex align-items-center justify-content-between mt-3'>
                <h5 className='text-info'>{`Laboratoristas Asignados`}</h5>
              </div>

              <Card className='mt-2' style={{ padding: 10 }}>
                <div className='d-flex align-items-start justify-content-start mb-3'>
                  <div className='col-3 col-md-4 mx-2'>
                      <label className='text-primary mt-3 rounded-3'>
                        <b>Validación de muestras: </b> { [...new Set(labRequestAssignments.filter(x => x.statusAssignment?.toLowerCase() === 'validación de muestras' && x.user).map(x => `${x.user.name ?? ''} ${x.user.surname ?? ''}`.trim()).filter(Boolean))].join(', ') || '-' }
                      </label>
                  </div>

                  <div className='col-3 col-md-4 mx-2'>
                    <label className='text-primary mt-3 rounded-3'>
                        <b>Validación de informes: </b> { [...new Set(labRequestAssignments.filter(x => x.statusAssignment?.toLowerCase() === 'validación de informes' && x.user).map(x => `${x.user.name ?? ''} ${x.user.surname ?? ''}`.trim()).filter(Boolean))].join(', ') || '-' }
                    </label>
                  </div>

                  <div className='col-3 col-md-4 mx-2'>
                    <label className='text-primary mt-3 rounded-3'>
                      <b>Pruebas de laboratorio: </b> { [...new Set(labRequestAssignments.filter(x => x.statusAssignment?.toLowerCase() === 'pruebas de laboratorio' && x.user).map(x => `${x.user.name ?? ''} ${x.user.surname ?? ''}`.trim()).filter(Boolean))].join(', ') || '-' }
                    </label>
                  </div>

                </div>
              </Card>

              <div className='d-flex align-items-center justify-content-between mt-3'>
                <h5 className='text-info'>{`Resumen de Ensayos`}</h5>
              </div>

              <Card className='mt-2' style={{ padding: 10 }}>
                <div className='d-flex align-items-start justify-content-start mb-3'>
                  <div className='col-3 col-md-6 mx-2'>
                      <label className='text-primary mt-3 rounded-3'>
                        <b> No. Total de Ensayos de la Solicitud </b> { labRequestsReportDetail?.totalEssays ?? '-' }
                      </label>
                  </div>

                  <div className='col-3 col-md-6 mx-2'>
                    <label className='text-primary mt-3 rounded-3'>
                        <b>Importe Total de la Solicitud: </b> $ { String(labRequestsReportDetail?.totalImport).toLocaleString('en-US', {maximumFractionDigits:2}) ?? '-' }
                    </label>
                  </div>

                </div>
              </Card>

              <Table1 renderRowSubComponent={renderRowSubComponent} isAddTableBorderStrap columns={columns} data={labRequestsReportDetail?.normsData ?? []} />
              <LabCitecDetailsTestEditModal props={props} setShowModal={setShowModal1} showModal={showModal1} modalHeader='Edición de estado' />
              <TableItemDeleteModal onDeleteConfirmation={onDeleteConfirmation} props={props} setShowModal={setShowModal2} showModal={showModal2} modalHeader='Eliminar Ensayos' modalBodyLabel='¿Está seguro que desea borrar el ensayo seleccionado?' />

            </Card>

          </Card>
        </Col>
      </Container>
    </div>
  )
}
